function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3267"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2946",
  d: "M47.415 36.696c18.719-12 30.847-20.545 44.7-25.183s63.791-6.52 80.167-6.933c23.368-.59 52.2-.9 54.531 6.63 3.1 10.014.183 66.342-5.994 98.778-8.846 46.447-22.789 113.056-30.743 120.582s-169.447 4.809-176.006-4.304-12.742-151.9-2.988-162.837c6.957-7.799 17.801-14.857 36.333-26.733z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3258"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2947",
  d: "M178.417 161.808c-5.2-5.645-51.623-26.748-62.8-22.284-7.378 2.947-21.4 26.8-17.184 32.025s58.88 5.5 72.724 13.469",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3259"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2948",
  d: "M44.135 34.64C63.594 22.17 76.203 13.281 90.607 8.461s66.314-6.778 83.338-7.207c24.292-.613 54.266-.936 56.689 6.893 3.221 10.41.19 68.97-6.231 102.691-9.2 48.286-23.691 117.535-31.96 125.358s-176.16 5-182.972-4.471S-3.775 73.811 6.369 62.437c7.227-8.112 18.5-15.45 37.766-27.797z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3260"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2949",
  d: "M6.958 84.523a15.971 15.971 0 011.188-3.006c3.742-5.927 21.026-10.615 32.477-12.432 6.712-1.065 14.509-1.993 22.32-2.687-7.681 6.872-9.12 22.394-2.8 37.591 3.913 9.407 10.012 16.793 16.532 20.911-26.752 20.906-56.825 43.276-63.7 45.792a11.575 11.575 0 01-5.428.789c-1.618-29.798-2.175-64.877-.589-86.958z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2950",
  d: "M81.587 65.213c5.089-.177 9.735-.193 13.543-.014 10.229.482 20.172 1.076 21.552 2.494 3.043 3.127 5.539 16.533 4.832 19.953-.189.917-7.135 6.96-17.454 15.409a51.1 51.1 0 00-3.855-15.734c-4.33-10.4-11.331-18.335-18.618-22.108z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2951",
  d: "M60.597 69.02c-5.559 7.725-6.064 21.473-.45 34.965q.244.588.5 1.164c-12.247 7.834-26.294 16.289-27.277 14.513-4.076-7.367-11.247-19.191-11.353-21.793-.033-.8 10.828-21.518 14.268-23.863 2.048-1.395 18.615-4.411 24.312-4.986z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3261"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 22",
  cx: 21.694,
  cy: 34.435,
  rx: 21.694,
  ry: 34.435,
  transform: "rotate(-22.59 204.262 -81.385)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3262"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 23",
  cx: 21.694,
  cy: 34.435,
  rx: 21.694,
  ry: 34.435,
  transform: "rotate(-22.59 204.262 -81.385)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3263"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 24",
  cx: 17.417,
  cy: 27.646,
  rx: 17.417,
  ry: 27.646,
  transform: "rotate(-22.589 217.657 -99.303)",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3264"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2952",
  d: "M70.732 100.164a5.457 5.457 0 011.182.17l.055.015.019.006.038.012.022.008.038.014.025.009.039.016.026.01.041.018.026.011.047.022.023.01.069.034h0l.13.067.019.01.132.073.026.015.14.082.022.013.154.094.192.123.064.043.137.092.08.055.131.091.087.062.133.1.091.067.14.1.09.068.157.119.08.062.222.175.022.017.25.2.081.067.176.145.1.085.162.136.109.093.161.139.112.1.166.146.109.1.181.163.1.088.244.225.039.035.285.267.092.089.2.188.113.11.179.175.122.12.174.174.123.124.177.18.121.123.189.2.109.114.244.258.055.06.3.32.1.109.2.221.227.255.033.039.255.292h0l.256.3.025.028.246.294.037.045.242.295.032.04.25.312h0l.251.32.022.028.24.313.035.044.234.313.03.04.241.328.128.179.07.1.067.093.071.1.064.092.071.1.063.091.07.1.062.092.071.1.06.09.07.106.06.09.07.108.037.057.083.128.069.11.056.087.069.11.056.09.067.11.055.09.067.111.053.09.067.112.052.089.067.114.05.085.067.118.012.021.1.17.067.12.044.082.064.118.048.087.062.117.048.089.061.116.046.089.06.119.045.087.06.121.04.081.062.127v.006l.091.189.061.13.034.074.058.125.039.084.055.123.039.087.053.122.037.087.053.123.035.085.053.126.031.078.053.134h0l.076.2.053.14.025.065.047.131.029.081.046.127.029.085.042.126.029.085.041.127.027.083.04.129.022.074.041.139q-1.689 1.338-3.415 2.7l-.276-.105h0l-.276-.11-.274-.114h-.009q-.41-.174-.821-.372l-.014-.006-.27-.132-.274-.139h0l-.269-.143-.025-.011-.267-.147-.266-.15-.017-.01-.265-.155-.008-.005-.269-.162-.263-.163-.022-.015-.262-.168-.265-.175-.011-.008-.258-.174-.024-.017-.258-.18-.256-.183-.024-.018-.252-.185-.022-.017-.255-.193-.251-.195-.031-.024-.249-.2-.014-.012-.245-.2-.017-.013-.243-.2-.034-.029-.246-.21-.243-.213-.03-.026-.237-.213-.033-.03-.241-.22-.238-.224-.037-.035-.233-.224-.026-.026-.225-.22-.019-.019-.23-.231-.04-.04-.229-.234-.013-.015-.22-.231-.033-.034-.222-.238-.039-.042-.226-.248-.224-.25-.04-.044-.216-.249-.033-.039-.208-.242-.019-.022-.215-.256-.042-.051-.213-.259-.024-.03-.2-.248-.033-.04-.207-.263-.04-.053-.21-.272-.006-.008-.2-.27-.039-.051-.2-.272-.037-.05-.193-.267-.013-.023-.2-.283-.041-.058-.2-.282-.029-.042-.182-.267-.028-.042-.191-.288-.04-.062-.191-.295-.015-.023-.18-.284-.036-.057-.184-.3-.037-.059-.181-.3-.008-.013-.184-.309-.039-.064-.177-.305-.03-.051-.165-.29-.023-.042-.175-.312-.037-.068-.173-.317-.019-.035-.159-.3-.031-.058-.166-.319-.034-.066-.169-.332-.019-.053a3.61 3.61 0 013.866-4.146z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3265"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2953",
  d: "M95.835 94.711c1.4.08 4.376 2.5 4.453 2.545l.045.265.013.087.029.178.015.1.024.163.017.108.022.156.015.11.021.155.015.109.021.157.013.105.02.167.012.094.023.2.006.059.028.261.006.062.019.2.008.092.016.167.008.1.013.158.008.1.012.155.008.1.01.159.006.1.01.166.005.089.01.189v.065l.012.257.01.256v.062l.005.191v1.335q0 .381-.021.757v.031l-.01.215v.046l-.01.2v.048l-.012.2v.044l-.014.212v.031l-.018.24q-2.727 2.214-5.686 4.59-.206-.856-.388-1.672v-.013l-.078-.353-.021-.092-.071-.326-.021-.1-.069-.326-.01-.042-.073-.356-.073-.364-.006-.026-.054-.278-.028-.145-.048-.254-.031-.162-.044-.244-.03-.166-.042-.237-.027-.163-.035-.2-.033-.2-.03-.188-.031-.2-.03-.189-.028-.195-.028-.193-.026-.183-.029-.216-.021-.153-.044-.343-.018-.15-.023-.209-.017-.157-.021-.2-.015-.152-.019-.206-.012-.134-.024-.306v-.09l-.017-.252-.007-.123-.01-.2-.006-.127-.008-.192v-.159l-.005-.243v-.542l.005-.225v-.012l.009-.213v-.031l.012-.209v-.037l.015-.208h0l.02-.2v-.035l.022-.189.005-.033.026-.184v-.007l.03-.182.005-.035.033-.172.015-.08.006-.023.023-.1.008-.031.017-.073.01-.037.017-.066.011-.038.019-.067.009-.031.03-.1v-.01l.027-.084.011-.031.022-.062.012-.034.022-.059.012-.031.027-.067.008-.021.037-.084.01-.021.028-.062.013-.028.026-.054.014-.028.028-.053.014-.025.04-.071h0l.044-.073.013-.022.032-.049.016-.026.031-.046.017-.023.035-.049.013-.017.05-.063.01-.013.04-.049.019-.02.035-.039.019-.021.037-.038.018-.019.047-.045.009-.008.057-.051.017-.014.042-.035.021-.017.04-.03.022-.016.044-.031.019-.013.063-.04.008-.005.057-.034.022-.012.044-.024.024-.012.046-.022.024-.012.055-.024.015-.007.071-.028.019-.007.054-.019.026-.008.049-.016.027-.008.053-.014.024-.006.077-.018a.888.888 0 01.189-.019z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2954",
  d: "M79.294 69.015c6.994 2.025 14.186 9.161 18.329 19.118a42.4 42.4 0 012.664 9.127c.084.09-3.435-2.8-4.71-2.527-3.613.782-2.522 9.232 1.166 22.113a12.431 12.431 0 01-4.583 3.5 11.678 11.678 0 01-5.534.82c-.243-9.658-12.359-20.227-14.714-20.833-2.491-.64-5.363.457-5.166 3.973.075.159.088.19 0 .017v-.017c-.221-.472-.985-2.073-1.286-2.794a37.821 37.821 0 01-2.949-18.981l-.006.088.031.244c.037.447.117 1.3.267 2.286.42 3.77.714 6.111 2.957 5.8l.066-.011h.018l.035-.007h.023l.019-.005.026-.006.021-.006h.03l.02-.005.032-.01.019-.005h.024l.048-.015.02-.007h.005l.091-.031h0l.014-.005.069-.025h.007l.162-.062.015-.006.017-.007.168-.07c.075-.031.152-.064.233-.1h0l.037-.017.181-.081.03-.014.021-.01.072-.033.119-.055.058-.027.039-.018.069-.033.088-.042.092-.044.057-.027.057-.028.062-.03.136-.066.069-.033.027-.014.7-.339.646-.316.584-.283.225-.109.143-.069.33-.157.077-.037.416-.2.12-.055.308-.143.16-.074.281-.128.174-.078.284-.127.175-.078.31-.135.173-.075.065-.028.391-.166h0l.394-.164.066-.027.387-.156.075-.031.4-.158.041-.015.393-.15.061-.023.087-.033.168-.062.1-.036a37.258 37.258 0 012.765-.9c9.225-2.612 14.138.794 14.261-.555.222-2.426-6.477-12.772-13.468-15.971z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2955",
  d: "M62.513 82.536l.014-.21a18.526 18.526 0 013.814-9.557c2.812 3.159 6.147 7.258 6.829 8.084a54.112 54.112 0 012.818 5.636s-3.672 1.43-9.367 4.22a2.051 2.051 0 01-2.764-.611 10.571 10.571 0 01-.813-2.945 99.593 99.593 0 01-.505-4.284c-.018-.213-.025-.334-.025-.334z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2956",
  d: "M119.299 56.801c1.084-1.4 17.094-12.814 24.1-16.127 6.8-3.215 17.474-4 24.083-4.16s15.076-1.457 17.5 1.31c1.386 1.586-.057 11.172-1.284 18.084-1.152 6.5-2.7 16.455-2.7 16.455s-61.189-1.127-61.748-2.365c-.883-1.952-.481-12.511.049-13.197z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2957",
  d: "M103.388 83.93c2.541 3.263 4.756 8.356 2.978 12.771-.036.089 13.235-8.834 13.434-9.877.912-4.786-2.278-9.888-2.278-9.888s-14.446 6.593-14.134 6.994z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3266"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2958",
  d: "M105.914 35.573c-.012-1.277-.473-1.829-1.525-1.972l-17.531-2.434a2.372 2.372 0 00-2.563 1.683l-.372 3.357c-.142 1.052.2 1.919 1.254 2.062l19.509 1.729c1.193-.22 1.168-.728 1.24-1.724z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2959",
  d: "M83.947 14.763c3.382 2.026 22.01 10.1 27.235 12.108 14.006 5.377 17.348 8.425 16.845 10.393-.556 2.176-8.6 8.988-14.957 14.212-6.248 5.136-18.358 13.854-22 13.624",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2960",
  d: "M132.072 32.992c4.1 2.293 4.753 2.667 7.049 3.425 1.131.373 16.536-5.809 16.841-6.734.227-.688-9.049-8.8-11.292-9.289-2.288-.5-20.151 6.2-19.712 8.1.186.805 3.009 2.205 7.114 4.498z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2961",
  d: "M119.927 7.332c5.276 2.368 13.769 6.722 13.515 7.563-.3 1-19.177 8.968-21.159 8.864-2.048-.107-18.531-7.4-23.206-11.155q1.512-.577 3.044-1.091c5.294-1.772 15.859-3.142 27.806-4.181z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2962",
  d: "M227.998 34.8c-.258 12.655-1.242 28.521-2.805 43.786a6.422 6.422 0 01-4.134-.378c-6.021-2.643-10.768-2.543-14.612-8.632s-.128-20.484 2.223-25.3c2.095-4.293 9.899-7.085 19.328-9.476z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2963",
  d: "M211.322 74.522c-5.371 2.657-12.114 14.632-16.632 20.271s-24.086 23.569-24.288 35.091.425 19.954 8.093 31.735",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2964",
  d: "M222.489 99.915c-8.231 14.462-75.514 82.607-42.616 103.643a863.983 863.983 0 0017.314 10.789",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2965",
  d: "M211.867 74.8c-4.715 3.5-9.556 24.159-13.982 32.028s-25.984 35.338-18.869 53.806",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2966",
  d: "M174.902 155.383c-6.067-5.9-39.823-31.669-56.054-20.713s-25.442 32.561-29.03 43.8 3.17 34.144 5.822 38.177 98.479 6.552 98.479 6.552",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2967",
  d: "M189.522 100.438c-10.943-.47-56.752-4.4-59.126-3.872-1.833.408-10.1 10.732-10.843 11.953-2.219 3.663.317 14.884 4.523 16.4 11.042 3.985 29.655 10.663 46.222 8.742",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2968",
  d: "M124.449 112.024c15.17.579 51.91 3.836 51.91 3.836",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2969",
  d: "M120.583 108.77c7.217.188 58.373 3.746 58.373 3.746",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2970",
  d: "M209.109 43.352c-5.764.417-14.507 4.739-10.305 16.4 1.211 3.362 3.877 7.453 6.335 6.486",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2971",
  d: "M202.479 65.588c-3.6.482-29.77 30.389-27.888 33.812",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2972",
  d: "M100.771 218.051c3.1 7.928 1.438 12.033 6.933 16.637",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgInteriorGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233.011,
    height: 241.744,
    viewBox: "0 0 233 242"
  }, props), _ref);
}

export default SvgInteriorGraphic;